import EditMember from "./EditMember";

export default EditMember;
